import React from "react";
import { Line } from "react-chartjs-2";
export default function AdherenceRateByProgram({ state }) {
  console.log(state.adherenceRateByPrograms);

  const adherenceRateByPrograms = state?.adherenceRateByPrograms || [];

  const programNames =
    adherenceRateByPrograms && adherenceRateByPrograms.map(y => y.programName);
  const enrolled =
    adherenceRateByPrograms && adherenceRateByPrograms.map(y => y.enrolled);
  const actives =
    adherenceRateByPrograms &&
    adherenceRateByPrograms.map(y =>
      Math.floor((y.actives / y.enrolled) * 100)
    );
  const lineChartData = {
    data: {
      labels: programNames,
      datasets: [
        {
          label: "Enrolados",
          data: enrolled,
          fill: false,
          backgroundColor: "#1A73D2",
          yAxisID: "A",
          type: "bar"
        },
        {
          label: "Tasa",
          data: actives,
          fill: false,
          yAxisID: "B",
          backgroundColor: "#DF681B"
        }
      ]
    },
    options: {
      scales: {
        yAxes: [
          {
            id: "A",
            position: "left",
            ticks: {
              callback: value => {
                return value % 1 === 0 ? Math.floor(value) : null;
              },
              min: 0
            }
          },
          {
            id: "B",
            position: "right",
            order: 2,
            ticks: {
              max: 100,
              callback: value => {
                return `${value}.00%`;
              },
              min: 0
            }
          }
        ]
      }
    }
  };

  return (
    <div style={{ height: "100%", width: "100%" }}>
      <Line
        data={lineChartData.data}
        options={lineChartData.options}
        // height={30}
        // width={80}
      />
    </div>
  );
}
